import { faker } from "@faker-js/faker";

import type { Todo } from "../models/Todo";
import { createTodoItem } from "./createTodoItem";

export function createTodo(
  override: NonNullable<Partial<Todo>> = {},
): NonNullable<Todo> {
  return {
    ...{
      id: faker.number.int(),
      company_id: faker.number.int(),
      created_by_id: faker.number.int(),
      name: faker.string.alpha(),
      description: faker.string.alpha(),
      status: faker.helpers.arrayElement<any>(["New", "Started", "Completed"]),
      percent_complete: faker.number.int(),
      todo_items: faker.helpers.arrayElements([createTodoItem()]) as any,
    },
    ...override,
  };
}
